<template>
<div>
  <h4 style="padding: 20px;">
    Capture and Save Remotely Scanned RFID Tags in Bulk
  </h4>
  <v-layout style="padding: 20px;">
    <!-- <v-layout> -->
    <v-flex xs4 row>
      <v-flex xs8 column>
      <p/><p/>
    <p>Tags this session: </p>
    <p>Number of Sessions: </p>
    <p>Total tags received: </p>
    
    </v-flex>
    <v-flex xs4 column>
      <p/><p/>
    <p>{{sessionCount}}</p>
    <p>{{numSessions}}</p>
    <p>{{total}}</p>
    </v-flex>
    <v-flex xs12>
    <p><v-btn color="blue" @click="saveTags">Save tags</v-btn></p>
    <p>Tags will be saved to temp_batch_tags</p><p/><p/>
    <p><v-btn color="orange" @click="resetTags">Reset captured tag table</v-btn></p>
    <p>This will empty the captured tags shown here.<br/>
    It will not empty the temp_batch_tags table.</p><p/><p/>
    <p><v-btn color="red" @click="emptyTable">Empty temp table</v-btn></p>
    <p>Warning! This will empty the temp_batch_tags table.</p>
    </v-flex>
    </v-flex>
    <v-flex xs8 column style="padding: 10px;">
      <table>
      <thead>
        <tr>
          <th class="first" style="padding-left: 10px;">Session</th>
          <th class="second">Number</th>
          <th class="third">Tag</th>
          <th class="fourth">CRC</th>
          <th class="fifth" style="padding-right: 10px;">CRC*</th>
        </tr>
      </thead>
      </table>
    <div :class="dark ? 'darkdiv' : 'lightdiv'" ref="tdiv" style="height: 70vh; overflow-y: scroll;">
      <table style="padding: 15px;" ref="ttable">
        <tbody>
          <tr :class="dark ? 'darkstripe': 'lightstripe'" v-for="i in tags" :key="i.tag">
            <td class="first" style="padding-left: 10px;">{{i.session}}</td>
            <td class="second">{{i.num}}</td>
            <td class="third">{{i.tag}}</td>
            <td class="fourth">{{i.crc}}</td>
            <td class="fifth" style="padding-right: 10px;">{{i.ccrc}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    </v-flex>
  </v-layout>
  
</div>
</template>

<script>
import { sync } from 'vuex-pathify'
import axiosInstances from '@/../../coreui/server/axiosInstances'
export default {
  data: () => ({
    mqttTopic: null,
    session: 0,
    sessionCount: 0,
    numSessions: 0,
    total: 0,
    tags: []
  }),
  computed:{
    mqttClient: sync('mqtt/origMqttClient'),
    dark: sync('misc/dark')
  },
  methods: {
    resetTags() {
      this.clear()
    },
    async emptyTable() {
      await axiosInstances.origApiServer.delete('/dt/v1/collections/temp_batch_tags')
    },
    async saveTags () {
      for (var i =0; i< this.total; i++) {
        await axiosInstances.origApiServer.post('/dt/v1/temp_batch_tags', this.tags[i])
      }
      this.clear()
    },
    scrollToEnd: function () {
      this.$refs.tdiv.scrollTop = this.$refs.tdiv.scrollHeight;
    },
    clear () {
      this.session = 0
      this.sessionCount = 0
      this.numSessions = 0
      this.total = 0
      this.tags = []
    }
  },
  created () {
    this.mqttTopic = 'entrinsia/bcast/@0C39AD7EB994'
    this.mqttClient.subscribe(this.mqttTopic, function (err) {
        if (err) console.log('mqtt subscribe error: ', err)
    })
    var self = this
    this.mqttClient.on('message', function (topic, message, packet) {
      let resp = JSON.parse(message.toString())
      let data = resp[0].data
      let tag = data.tag
      if (tag == null) return
      if (self.tags.filter(e => e.tag === tag).length > 0) {
        return
      }
      if (data.num == 1) {
        self.numSessions++
        self.sessionCount = 0
      }
      self.sessionCount++
      self.total++
      if (isNaN(tag.substring(tag.length - 9))) return
      self.tags.push({
        session: self.numSessions, 
        num: self.sessionCount, 
        tag: tag, 
        crc: data.crc, 
        ccrc: data.ccrc})
      self.$nextTick(() => self.scrollToEnd())
    })
  },
  mounted () {
    this.clear()
  },
  destroyed () {
    if (this.mqttTopic != null) {
      this.mqttClient.unsubscribe(this.mqttTopic)
    }
  }
}
</script>
<style scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}

.first {
  text-align: left;
  width: 10%
}

.second {
  text-align: center;
  width: 10%;
}

.third {
  text-align: right;
  width: 50%;
}

.fourth {
  text-align: right;
  width: 15%;
}

.fifth {
  text-align: right;
  width: 15%;
}

th {
  text-align: right;
  background-color: green;
  border: 1pt solid gray;
}
tr.lightstripe:nth-child(even) {
  background-color: #D3D3D3;
}
tr.darkstripe:nth-child(even) {
  background-color: #36454F;
}
.darkdiv {
  box-shadow: inset 0 0 10px #36454F;
}
.lightdiv {
  box-shadow: inset 0 0 10px #D3D3D3;
}
</style>
